<template>
    <div class="article-title color-blue fs12">
        <div v-if="link2"><span class="hand-shape" @click="toLink(link1)">{{title1}}</span> > <span class="hand-shape" @click="toLink(link2)">{{title2}}</span></div>
        <div v-else><span class="hand-shape" @click="toLink(link1)">{{title1}}</span> > {{title2}}</div>
    </div>           
</template>
<script>
export default {
    props: ['title1','title2','link1','link2'],
    data() {
        return {};
    },
    methods: {
        toLink(url){
            this.$router.push(url);
        }
    }
};
</script>
<style scoped>
.tab-content{margin-bottom:20px;height:220px;padding:20px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(13,52,130,0.1);border-radius:5px;}
.tab-content:hover{box-shadow:0px 0px 10px 0px rgba(13,52,130,0.4);}
.tab-content .img-left{width:180px;height:180px;margin-right:20px;position: relative;}
.tab-content .img-left .img-branch{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
}
/* .tab-content .img-left .img-branch{
    width:auto;
    height:auto;
    max-width: 100%;
    max-height:100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.tab-content .img-left .img-branch-ie9{
    width:100%\9\0!important;
    height:100%\9\0!important;
    display: block\9\0!important;
} */
.tab-content .img-right{width:960px;}
.tab-content .img-right .title{line-height:25px;}
.tab-content .img-right .describe{color:#666;line-height:24px;}
</style>


// WEBPACK FOOTER //
// src/components/breadItem.vue